import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { FOUNDER_IMG } from "@/assets";

export const Founder = () => {
  const { t } = useLang();
  return (
    <section data-testid="founder-section" className="relative py-24 sm:py-32 bg-gradient-to-b from-[#0b0906] to-[#050505] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="relative overflow-hidden border border-[#d4af37]/30 max-w-md mx-auto lg:mx-0">
            <img src={FOUNDER_IMG} alt={t.founder.name} loading="lazy" decoding="async" className="w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/40 to-transparent pointer-events-none" />
          </div>
          <span className="hidden lg:block absolute -bottom-6 -right-4 font-serif-lux text-[6rem] leading-none text-[#d4af37]/10 select-none">JN</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37]">{t.founder.label}</span>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl mt-4 text-white">{t.founder.name}</h2>
          <p className="mt-2 text-[#d4af37]/90 text-sm sm:text-base tracking-wide">{t.founder.role}</p>
          <p className="mt-8 font-serif-lux italic text-2xl sm:text-3xl font-light text-white/90 leading-snug">
            {t.founder.quote}
          </p>
          <p className="mt-6 text-base font-light leading-relaxed text-white/60 max-w-xl">{t.founder.bio}</p>
        </motion.div>
      </div>
    </section>
  );
};
